<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <el-badge
          v-if="allow('V')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="approved-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('V')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="approved"
          >
            {{ $l('btn_information_review') || '信息审核通过' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <SkuDetail
      v-if="skuDetailOpts.visible"
      :type="skuDetailOpts.type"
      :visible.sync="skuDetailOpts.visible"
      :evgSkuCode="skuDetailOpts.evgSkuCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import SkuDetail from '../detail'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SkuDetail },
  data() {
    return {
      usePage: true,
      checkedRows: [],
      skuDetailOpts: {
        visible: false,
        type: '',
        evgSkuCode: '',
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomEvgSkuListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.clearCheckboxRow()
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    async approved() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('message_pl_select_approved_sku') ||
            '请选择需要审核通过的SKU',
          type: 'warning',
        })
        return
      }
      const listEvgSkuCode = this.checkedRows.map((row) => row.evgSkuCode)

      const confirm = await this.$confirm(
        this.$l('tips_approved_sku_content') || '是否要通过转正？',
        this.$l('tips_approved_sku_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_approved_sku_confirm') || '确定',
          cancelButtonText: this.$l('btn_approved_sku_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgSkuInformationApprovedApi({ listEvgSkuCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(
          this.$l('tips_pass_sku_error') || '通过失败！'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_pass_sku_success') || '通过成功！',
        type: 'success',
      })
      this.reload()
    },
    openEditDialog({ type, data = {} } = {}) {
      const { evgSkuCode } = data
      this.skuDetailOpts = { visible: true, type, evgSkuCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.approved-button {
  .el-icon-circle-close {
    display: none;
  }
}
.approved-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
